/** 正式环境 API / WebSocket；本地开发见 .env.development */
export const API_BASE =
  process.env.VUE_APP_API_BASE ||
  (process.env.NODE_ENV === 'production' ? 'https://apiv1.between-us.vip' : 'http://localhost:8000');

export const WS_URL =
  process.env.VUE_APP_WS_URL ||
  (process.env.NODE_ENV === 'production' ? 'wss://ws.between-us.vip' : 'ws://127.0.0.1:8787');
